import { render } from "./PaymentSuccess.vue?vue&type=template&id=564f876a&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=564f876a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564f876a"]])

export default __exports__